import { EventPeriodEnum, EventTypeEnum, EventVm } from '../utils/api';

export const EVENT_INCOMPLETE = 'This event is missing a player or a result.';
export const ALREADY_THE_GOALKEEPER = 'That player is already the goalkeeper.';
export const GOALKEEPER_REQUIRED = 'Pick the new goalkeeper.';
export const GOALKEEPER_SAME_SECOND = 'A goalkeeper change is already at this time.';
export const DELETE_ALREADY_QUEUED = 'Delete is already queued.';
export const EDIT_DROPPED_FOR_DELETE = 'The edit was dropped because this event is being deleted.';

/** True when the form has a lineup row for the incoming goalkeeper. */
export const goalkeeperChangeIsComplete = (
    change: { newGoalkeeperMatchPlayerId?: number | null } | null | undefined
): boolean => (change?.newGoalkeeperMatchPlayerId ?? 0) > 0;

/** True when another change by the same team already occupies this clock outside PSO. */
export const goalkeeperChangeAtSameSecond = (
    events: EventVm[],
    candidate: { id?: number; periodId?: number; minute?: number; seconds?: number; teamId?: number; isShootout?: boolean }
): boolean =>
    !(candidate.periodId === EventPeriodEnum.Overtime && candidate.isShootout) && events.some(
        (event) =>
            event.typeId === EventTypeEnum.Goalkeeper_Change &&
            event.goalkeeperChange?.teamId === candidate.teamId &&
            event.periodId === candidate.periodId &&
            event.minute === candidate.minute &&
            event.seconds === candidate.seconds &&
            event.id !== candidate.id
    );
